import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardShell from "@/components/DashboardShell";
import { CANDIDATE_NAV } from "./nav";
import api from "@/lib/api";
import { FileText } from "lucide-react";

const STATUS_COLORS = {
  Applied: "bg-blue-50 text-blue-700", "Under Review": "bg-amber-50 text-amber-700",
  Shortlisted: "bg-purple-50 text-purple-700", Interview: "bg-indigo-50 text-indigo-700",
  Selected: "bg-emerald-50 text-emerald-700", Rejected: "bg-red-50 text-red-700",
};

export default function Applications() {
  const [apps, setApps] = useState(null);
  useEffect(() => { api.get("/me/applications").then((r) => setApps(r.data)).catch(() => setApps([])); }, []);

  return (
    <DashboardShell nav={CANDIDATE_NAV}>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-5">My Applications</h1>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        {apps === null ? <div className="h-40 animate-pulse" /> : apps.length === 0 ? (
          <div className="text-center py-16"><FileText className="w-10 h-10 text-slate-300 mx-auto mb-3" /><p className="text-slate-500">No applications yet.</p><Link to="/jobs" className="text-[#D96B27] text-sm">Browse jobs →</Link></div>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-slate-400 border-b border-slate-100 bg-slate-50"><th className="py-3 px-4 font-medium">Company</th><th className="py-3 px-4 font-medium">Job</th><th className="py-3 px-4 font-medium">Applied</th><th className="py-3 px-4 font-medium">Status</th></tr></thead>
            <tbody>
              {apps.map((a) => (
                <tr key={a.application_id} data-testid={`app-row-${a.application_id}`} className="border-b border-slate-50 hover:bg-slate-50">
                  <td className="py-3 px-4 text-slate-700">{a.company_name}</td>
                  <td className="py-3 px-4 font-medium text-slate-800">{a.job_title}</td>
                  <td className="py-3 px-4 text-slate-400">{a.applied_at?.slice(0, 10)}</td>
                  <td className="py-3 px-4"><span className={`text-xs px-2 py-0.5 rounded ${STATUS_COLORS[a.status] || "bg-slate-100"}`}>{a.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </DashboardShell>
  );
}
